import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ICardData } from "@tylertech/tyler-api-types";

@Injectable()
export class DetailDialogService
{
    private readonly $apiService = inject(ApiService);


    getDetail(endpoint: string, model: unknown): Promise<ExecutionResult<Array<ICardData>>>
    {
        return this.$apiService.sendAuth(endpoint, model);
    }
}
